import {
    isFeatureEnabled,
    toFeatureState,
} from '@west-australian-newspapers/etrigan-feature-toggles-client'
import { bestAustralianYarnSegment } from '../../home/best-australian-yarn-segment'
import { GetMainSectionFn } from '../custom-topic-routes'

type GenWestTopic =
    | 'news'
    | 'features'
    | 'sport'
    | 'arts'
    | 'books'
    | 'careers'
    | 'snapshot'
    | 'what-s-hot'
    | 'puzzles'
    | 'best-australian-yarn'

const getSection = (topic: GenWestTopic, heading?: string) => {
    return {
        type: 'lima',
        props: {
            verticalSpacing: 'xl',
            fontScale: 1.2,
            fixedRatios: ['16:9'],
            hasBackground: true,
            teaserMode: {
                initial: 'visible',
                xs: 'visible',
                sm: 'hidden',
                md: 'hidden',
            },
            initialColumns: 1,
            intermediateColumns: 2,
            finalColumns: 4,
            cardOrientation: { type: 'Landscape-Portrait' },

            sectionHeader: {
                heading: heading ? heading : topic,
                headingUrl: '/genwest/' + topic,
            },

            dataDefinitionArgs: {
                type: 'listing',
                topics: ['genwest/' + topic],
                includeSubTopics: false,
                paging: {
                    page: 1,
                    pageSize: 4,
                },
            },
        },
    }
}

export const getGenwestRouteInfo: GetMainSectionFn = (
    sectionBuilder,
    store,
): any => {
    const bayIsEnabled = isFeatureEnabled(
        toFeatureState(store!.getState().toggles),
        'best-australian-yarn-gen-west',
        true,
    )

    const BAY = []
    if (bayIsEnabled) {
        BAY.push(bestAustralianYarnSegment({ isGenwest: true }))
    }

    const sections = [
        ...sectionBuilder.getCuratedSection(undefined, true),
        ...BAY,
        getSection('news'),
        getSection('features'),
        getSection('sport'),
        getSection('arts'),
        getSection('books'),
        getSection('careers'),
        getSection('snapshot'),
        getSection('what-s-hot', `What's Hot`),
        getSection('puzzles'),
    ]
    return sections
}
